// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dTGj","badges":"styles_badges__2kWmt"};